import { toggleDialog } from "../../utils";

export const setupBurgerMenu = (
  burgerMenu: HTMLElement | null,
  navList: HTMLElement | null,
  fullPageOverlayControl: HTMLButtonElement | null,
) => {
  burgerMenu?.addEventListener("click", () => {
    const isMenuOpen = burgerMenu.getAttribute("aria-expanded") === "true";

    if (isMenuOpen) {
      closeMenu(burgerMenu, navList, fullPageOverlayControl);
    } else {
      openMenu(burgerMenu, navList, fullPageOverlayControl);
    }
  });
};

const closeMenu = (
  burgerMenu: HTMLElement,
  navList: HTMLElement | null,
  fullPageOverlayControl: HTMLButtonElement | null,
) => {
  navList?.classList.add("hidden");
  burgerMenu.setAttribute("aria-expanded", "false");
  toggleDialog(fullPageOverlayControl?.parentElement, false);
};

const openMenu = (
  burgerMenu: HTMLElement,
  navList: HTMLElement | null,
  fullPageOverlayControl: HTMLButtonElement | null,
) => {
  navList?.classList.remove("hidden");
  burgerMenu.setAttribute("aria-expanded", "true");
  toggleDialog(fullPageOverlayControl?.parentElement, true);
};

